import http from '../http';

// 打印抽屉信息
export const fetchPrintInfoList = (params) => {
  return http({
    url: `/bill/bill-print/${params.resvNo}`,
  });
};
